import React from 'react'
import PropTypes from 'prop-types';
import { Col, Row, Tag } from 'antd';
import { displayNumbers } from '../../../../variables/numbersFunctions';
import { LOGGED_USER } from '../../../../variables/constants';

const PreviewFicheDeclaration = (props) => {
    return (
        <div style={{
            background: '#fff',
            borderRadius: '16px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            overflow: 'hidden'
        }}>
            {/* En-tête du document */}
            <div style={{
                background: '#242166',
                padding: '2px',
                color: '#fff',
                textAlign: 'center'
            }}>
                <h1
                    style={{
                        margin: 0,
                        fontSize: '32px',
                        fontWeight: 'bold',
                        letterSpacing: '1px',
                        textTransform: 'uppercase',
                        color: '#fff'
                    }}
                >
                    Déclaration de Sinistre ({props?.sequenceSinistre ? `#S${props?.contrat?.codeCat}${LOGGED_USER?.profil?.organisme?.code}${props?.sinistre?.typeSinistre === 'MIXTE' ? 'X' : props?.sinistre?.typeSinistre === "MATERIEL" ? 'M' : 'C'}${String(props.sequenceSinistre).padStart(5, '0')}/${String(new Date().getFullYear()).slice(-2)}` : 'N/A'})
                </h1>
                <div style={{
                    marginTop: '4px',
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '6px',
                    fontSize: '14px'
                }}>
                    <div>
                        <strong>Date de déclaration:</strong> {new Date().toLocaleDateString('fr-FR')}
                    </div>
                    <div>
                        <strong>Heure:</strong> {new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                    </div>
                </div>
            </div>

            <div style={{ padding: '32px' }}>
                {/* Détails de l'accident */}
                <div style={{
                    marginBottom: '32px',
                    border: '2px solid #667eea',
                    borderRadius: '12px',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                        padding: '16px 24px',
                        borderBottom: '2px solid #667eea'
                    }}>
                        <h3 style={{ margin: 0, color: '#1565c0', fontSize: '18px', fontWeight: 'bold' }}>
                            📋 Détails de l'Accident
                        </h3>
                    </div>
                    <div style={{ padding: '24px' }}>
                        <Row gutter={[24, 16]}>
                            <Col xs={12} sm={8}>
                                <div style={{ marginBottom: '8px' }}>
                                    <div style={{ fontSize: '11px', color: '#666', fontWeight: '600', textTransform: 'uppercase' }}>
                                        N° de Police
                                    </div>
                                    <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#333' }}>
                                        {props?.contrat?.numeroPoliceP || '-'}
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} sm={8}>
                                <div style={{ marginBottom: '8px' }}>
                                    <div style={{ fontSize: '11px', color: '#666', fontWeight: '600', textTransform: 'uppercase' }}>
                                        Date du Sinistre
                                    </div>
                                    <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#333' }}>
                                        {props?.sinistre?.dateSurvenance?.format('DD/MM/YYYY') || '-'}
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} sm={8}>
                                <div style={{ marginBottom: '8px' }}>
                                    <div style={{ fontSize: '11px', color: '#666', fontWeight: '600', textTransform: 'uppercase' }}>
                                        Heure
                                    </div>
                                    <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#333' }}>
                                        {props?.sinistre?.heureSurvenance?.format('HH:mm') || '-'}
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24}>
                                <div style={{ marginBottom: '8px' }}>
                                    <div style={{ fontSize: '11px', color: '#666', fontWeight: '600', textTransform: 'uppercase' }}>
                                        Lieu du Sinistre
                                    </div>
                                    <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#333' }}>
                                        {props?.sinistre?.lieu || '-'} {props?.sinistre?.quartier ? `Qt. ${props?.sinistre?.quartier}` : props?.sinistre?.commune ? `Cm. ${props?.sinistre?.commune}` : ''} {props?.selectedLocation ? `(Pref. ${props?.selectedLocation?.prefecture?.nom} | Reg. ${props?.selectedLocation?.region?.nom})` : ''}
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <div style={{ marginBottom: '8px' }}>
                                    <div style={{ fontSize: '11px', color: '#666', fontWeight: '600', textTransform: 'uppercase' }}>
                                        Conducteur
                                    </div>
                                    <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#333' }}>
                                        {props?.isAssureConducteur ? 'Assuré' : `${props?.sinistre?.conducteur?.prenom || ''} ${props?.sinistre?.conducteur?.nom || ''}`}
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <div style={{ marginBottom: '8px' }}>
                                    <div style={{ fontSize: '11px', color: '#666', fontWeight: '600', textTransform: 'uppercase' }}>
                                        Véhicule
                                    </div>
                                    <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#333' }}>
                                        {props?.sinistre?.enginId || '-'}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>

                {/* Informations de l'assuré */}
                <div style={{
                    marginBottom: '32px',
                    border: '2px solid #43e97b',
                    borderRadius: '12px',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
                        padding: '16px 24px',
                        borderBottom: '2px solid #43e97b'
                    }}>
                        <h3 style={{ margin: 0, color: '#2e7d32', fontSize: '18px', fontWeight: 'bold' }}>
                            👤 Informations de l'Assuré
                        </h3>
                    </div>
                    <div style={{ padding: '24px' }}>
                        <Row gutter={[24, 16]}>
                            <Col xs={24} sm={12}>
                                <div style={{ marginBottom: '8px' }}>
                                    <div style={{ fontSize: '11px', color: '#666', fontWeight: '600', textTransform: 'uppercase' }}>
                                        Contrat
                                    </div>
                                    <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#333' }}>
                                        {props?.contrat?.numeroPoliceP || '-'}
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={12}>
                                <div style={{ marginBottom: '8px' }}>
                                    <div style={{ fontSize: '11px', color: '#666', fontWeight: '600', textTransform: 'uppercase' }}>
                                        Assuré
                                    </div>
                                    <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#333' }}>
                                        {props?.contrat?.prenom || ''} {props?.contrat?.nom || '-'}
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={12}>
                                <div style={{ marginBottom: '8px' }}>
                                    <div style={{ fontSize: '11px', color: '#666', fontWeight: '600', textTransform: 'uppercase' }}>
                                        Immatriculation
                                    </div>
                                    <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#333' }}>
                                        {props?.sinistre?.enginId || '-'}
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={12}>
                                <div style={{ marginBottom: '8px' }}>
                                    <div style={{ fontSize: '11px', color: '#666', fontWeight: '600', textTransform: 'uppercase' }}>
                                        Marque
                                    </div>
                                    <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#333' }}>
                                        {props?.contrat?.marque || '-'}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>

                {/* Adversaires */}
                {props?.adversaires.length > 0 && (
                    <div style={{
                        marginBottom: '32px',
                        border: '2px solid #f5576c',
                        borderRadius: '12px',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)',
                            padding: '16px 24px',
                            borderBottom: '2px solid #f5576c'
                        }}>
                            <h3 style={{ margin: 0, color: '#c62828', fontSize: '18px', fontWeight: 'bold' }}>
                                👥 Adversaires ({props?.adversaires.length})
                            </h3>
                        </div>
                        <div style={{ padding: '24px' }}>
                            {props?.adversaires.map((adv, index) => (
                                <div
                                    key={adv.id}
                                    style={{
                                        background: '#fafafa',
                                        borderRadius: '8px',
                                        padding: '16px',
                                        marginBottom: index < props?.adversaires.length - 1 ? '16px' : 0,
                                        border: '1px solid #e0e0e0'
                                    }}
                                >
                                    <div style={{
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                        color: '#f5576c',
                                        marginBottom: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        <Tag color={adv.typeAdversaire?.startsWith('VEHICULE') ? 'blue' : adv.typeAdversaire === 'PIETON' ? 'green' : 'orange'}>
                                            {adv.typeAdversaire}
                                        </Tag>
                                        Adversaire {index + 1}
                                    </div>
                                    <Row gutter={[16, 12]}>
                                        <Col xs={12} sm={8}>
                                            <div style={{ fontSize: '11px', color: '#666', fontWeight: '600' }}>NOM</div>
                                            <div style={{ fontSize: '14px', fontWeight: '500' }}>{adv.nom || '-'}</div>
                                        </Col>
                                        <Col xs={12} sm={8}>
                                            <div style={{ fontSize: '11px', color: '#666', fontWeight: '600' }}>PRÉNOM</div>
                                            <div style={{ fontSize: '14px', fontWeight: '500' }}>{adv.prenom || '-'}</div>
                                        </Col>
                                        <Col xs={12} sm={8}>
                                            <div style={{ fontSize: '11px', color: '#666', fontWeight: '600' }}>TÉLÉPHONE</div>
                                            <div style={{ fontSize: '14px', fontWeight: '500' }}>{adv.telephone || '-'}</div>
                                        </Col>
                                        {adv.immatriculation && (
                                            <Col xs={24}>
                                                <div style={{ fontSize: '11px', color: '#666', fontWeight: '600' }}>IMMATRICULATION</div>
                                                <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#1976d2' }}>
                                                    {adv.immatriculation}
                                                </div>
                                            </Col>
                                        )}
                                    </Row>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Circonstances */}
                <div style={{
                    marginBottom: '32px',
                    border: '2px solid #ff9800',
                    borderRadius: '12px',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
                        padding: '16px 24px',
                        borderBottom: '2px solid #ff9800'
                    }}>
                        <h3 style={{ margin: 0, color: '#e65100', fontSize: '18px', fontWeight: 'bold' }}>
                            📝 Circonstances de l'Accident
                        </h3>
                    </div>
                    <div style={{ padding: '24px' }}>
                        <div style={{
                            background: '#fafafa',
                            padding: '16px',
                            borderRadius: '8px',
                            border: '1px solid #e0e0e0',
                            fontSize: '14px',
                            lineHeight: '1.6',
                            color: '#333',
                            minHeight: '100px'
                        }}>
                            {props?.sinistre?.circonstances || 'Aucune circonstance renseignée'}
                        </div>
                    </div>
                </div>

                {/* Évaluation */}
                <div style={{
                    marginBottom: '32px',
                    border: '2px solid #9c27b0',
                    borderRadius: '12px',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)',
                        padding: '16px 24px',
                        borderBottom: '2px solid #9c27b0'
                    }}>
                        <h3 style={{ margin: 0, color: '#6a1b9a', fontSize: '18px', fontWeight: 'bold' }}>
                            💰 Évaluation des Dommages
                        </h3>
                    </div>
                    <div style={{ padding: '24px' }}>
                        {(props?.sinistre?.typeSinistre === 'CORPOREL' || props?.sinistre?.typeSinistre === 'MIXTE') && (
                            <div style={{ marginBottom: '24px' }}>
                                <div style={{
                                    fontSize: '13px',
                                    fontWeight: 'bold',
                                    color: '#6a1b9a',
                                    marginBottom: '12px'
                                }}>
                                    Bilan Corporel
                                </div>
                                <Row gutter={16}>
                                    <Col xs={12} sm={6}>
                                        <div style={{ textAlign: 'center', background: '#f3e5f5', padding: '12px', borderRadius: '8px' }}>
                                            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#6a1b9a' }}>
                                                {props?.sinistre?.nbBlessesLegers || 0}
                                            </div>
                                            <div style={{ fontSize: '11px', color: '#666' }}>Blessés légers</div>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={6}>
                                        <div style={{ textAlign: 'center', background: '#f3e5f5', padding: '12px', borderRadius: '8px' }}>
                                            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#6a1b9a' }}>
                                                {props?.sinistre?.nbBlessesMoyens || 0}
                                            </div>
                                            <div style={{ fontSize: '11px', color: '#666' }}>Blessés moyens</div>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={6}>
                                        <div style={{ textAlign: 'center', background: '#f3e5f5', padding: '12px', borderRadius: '8px' }}>
                                            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#6a1b9a' }}>
                                                {props?.sinistre?.nbBlessesGraves || 0}
                                            </div>
                                            <div style={{ fontSize: '11px', color: '#666' }}>Blessés graves</div>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={6}>
                                        <div style={{ textAlign: 'center', background: '#f3e5f5', padding: '12px', borderRadius: '8px' }}>
                                            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#6a1b9a' }}>
                                                {props?.sinistre?.nbDeces || 0}
                                            </div>
                                            <div style={{ fontSize: '11px', color: '#666' }}>Décès</div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        )}

                        {(props?.sinistre?.typeSinistre === 'MATERIEL' || props?.sinistre?.typeSinistre === 'MIXTE') && props?.sinistre?.typeDegatsMateriels && (
                            <div style={{ marginBottom: '24px' }}>
                                <div style={{
                                    fontSize: '13px',
                                    fontWeight: 'bold',
                                    color: '#6a1b9a',
                                    marginBottom: '12px'
                                }}>
                                    Type de Dégâts Matériels
                                </div>
                                <Tag color="purple" style={{ fontSize: '14px', padding: '8px 16px' }}>
                                    {props?.sinistre?.typeDegatsMateriels === 'LEGERS' && 'Dégâts légers'}
                                    {props?.sinistre?.typeDegatsMateriels === 'MOYENS' && 'Dégâts moyens'}
                                    {props?.sinistre?.typeDegatsMateriels === 'IMPORTANTS' && 'Dégâts importants'}
                                    {props?.sinistre?.typeDegatsMateriels === 'EXTREMES' && 'Cas extrêmes'}
                                </Tag>
                            </div>
                        )}

                        <div style={{
                            background: 'linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)',
                            padding: '20px',
                            borderRadius: '12px',
                            textAlign: 'center'
                        }}>
                            <div style={{ fontSize: '14px', color: '#6a1b9a', marginBottom: '8px', fontWeight: '600' }}>
                                ÉVALUATION INITIALE
                            </div>
                            <div style={{ fontSize: '32px', fontWeight: 'bold', color: 'black' }}>
                                {displayNumbers(props?.sinistre?.evaluationInitiale || 0)} FCFA
                            </div>
                        </div>

                        {props?.sinistre?.garanties?.length > 0 && (
                            <div style={{ marginTop: '20px' }}>
                                <div style={{
                                    fontSize: '13px',
                                    fontWeight: 'bold',
                                    color: '#6a1b9a',
                                    marginBottom: '12px'
                                }}>
                                    Garanties Affectées
                                </div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                    {props?.sinistre?.garanties
                                        .map(g => (
                                            <Tag key={g} color="#6a1b9a" style={{ fontSize: '13px', padding: '6px 12px' }}>
                                                {g?.startsWith("RC") ? "RC" : g}
                                            </Tag>
                                        ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Victimes supplémentaires */}
                {props?.victimes?.length > 0 && (
                    <div style={{
                        marginBottom: '32px',
                        border: '2px solid #52c41a',
                        borderRadius: '12px',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
                            padding: '16px 24px',
                            borderBottom: '2px solid #52c41a'
                        }}>
                            <h3 style={{ margin: 0, color: '#2e7d32', fontSize: '18px', fontWeight: 'bold' }}>
                                🏥 Victimes ({props?.victimes?.length})
                            </h3>
                        </div>
                        <div style={{ padding: '24px' }}>
                            <Row gutter={[16, 16]}>
                                {props?.victimes?.map((victime, index) => (
                                    <Col xs={24} sm={12} md={8} key={victime.id}>
                                        <div style={{
                                            background: '#fafafa',
                                            borderRadius: '8px',
                                            padding: '16px',
                                            border: '1px solid #e0e0e0'
                                        }}>
                                            <div style={{ fontWeight: 'bold', marginBottom: '8px', color: '#2e7d32' }}>
                                                {index + 1}. {victime.nom} {victime.prenom}
                                            </div>
                                            {victime.profession && (
                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                                                    💼 {victime.profession}
                                                </div>
                                            )}
                                            {victime.telephone && (
                                                <div style={{ fontSize: '12px', color: '#666' }}>
                                                    📞 {victime.telephone}
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </div>
                )}

                {/* Signature */}
                <div style={{
                    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                    padding: '24px',
                    borderRadius: '12px',
                    textAlign: 'center'
                }}>
                    <Row gutter={32} justify="center">
                        <Col xs={24} sm={8}>
                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Fait à</div>
                            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Lomé</div>
                        </Col>
                        <Col xs={24} sm={8}>
                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Le</div>
                            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                {new Date().toLocaleDateString('fr-FR')}
                            </div>
                        </Col>
                        <Col xs={24} sm={8}>
                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Signature de l'assuré</div>
                            <div style={{
                                height: '60px',
                                border: '2px dashed #999',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#999',
                                fontSize: '12px'
                            }}>
                                [Signature]
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

PreviewFicheDeclaration.propsTypes = {
    sinistre: PropTypes.object,
    victimes: PropTypes.array,
    contrat: PropTypes.object,
    adversaires: PropTypes.array,
    isAssureConducteur: PropTypes.bool,
    selectedLocation: PropTypes.object
}


export default PreviewFicheDeclaration